import { createSlice } from "@reduxjs/toolkit";
import { server_url } from "../core/config_geral";
const initialState = {
    loading: true,
    error : false,
    lista : [],
    totalNaoVistas : 0
}

export const notificacoesSlice = createSlice({
    name: "notificacoes",
    initialState,
    reducers: {
        triggerLoadNotificacoes : () => {},
        triggerMarkRead : () => {},
        triggerVisualizarTodas : () => {},
        setAttrNotificacoes : (state, action) => {
            state[action.payload.campo] = action.payload.value
        }
    }});


    export const {
        triggerLoadNotificacoes,
        triggerMarkRead,
        triggerVisualizarTodas,
        setAttrNotificacoes,

    } = notificacoesSlice.actions;
    
    export default notificacoesSlice.reducer;